/*eslint-disable */
var $ = window.jQuery = require('jquery');
import adapter from 'webrtc-adapter';
import socketRef from "../../socket";
import { bus } from '../../main';
import toast from '../../services/toast';
import videoSocketRef from "../../videoNotificationSocket";
import {
  mapGetters,
} from 'vuex';
import VideoBox from './VideoBox'

export default {
  name: 'video-conference-chat',
  components: {
    VideoBox
  },
  props: [],
  data() {
    return {
      screenShareConstraints: {
        video: true,
        audio: true
      },
      constraints: {
        audio: {
          'echoCancellation': true
        },
        video: {
          aspectRatio: {
            min: 1.333,
            max: 1.333
          },
          facingMode: "user",
          width: {
            min: 480,
            ideal: 720,
            max: 920
          },
          height: {
            min: 360,
            ideal: 720,
            max: 690
          },
          frameRate: {
            min: 30,
            max: 40
          }
        }
      },
      configuration: undefined,
      offerOptions: {
        offerToReceiveAudio: true,
        offerToReceiveVideo: true
      },
      roomID: '',
      currentUser: '',
      isAudioMuted: false,
      isVideoMuted: false,
      localVideo: undefined,
      localStream: undefined,
      userProfileDetails:{},
      userIdForRoomId:'',
      userFullName:'',
      peerConnections: {},
      peers: [],
      screenExpandbleOption:false,
      hasInternetConnection: true,
      isOnline: true,
      isScreenSharing: false,
      disableScreenSharing: false,
      screenSharedPeerUuuid:''
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters',
    ]),
    getUserDetailsInfo(){
      this.userProfileDetails = this.$store.getters.acUserDetailsStateGetters.data;
      return
    },
    setIntialUserIdFun(){
      if(this.userProfileDetails != undefined){
        this.userIdForRoomId = this.userProfileDetails.id
        this.userFullName = this.userProfileDetails.first_name + ' ' + this.userProfileDetails.last_name
      }
    }
  },
  created() {
    this.getUserDetailsInfo
    this.setIntialUserIdFun
    if (!location.hash) {
      location.hash = Math.floor(Math.random() * 0xFFFFFF).toString(16);
    }
    this.roomID = location.hash.substring(1);
    this.currentUser =  this.userIdForRoomId;
  },
  mounted() {
    this.getUserDetailsInfo;
    this.setIntialUserIdFun;
    bus.$emit('videoCreatingMenuBus', false);
    $('.app-loader').hide();
    $('.routeloader').hide();
    console.log(`Browser ${adapter.browserDetails.browser} - version ${adapter.browserDetails.version}`);
    $(document).ready(function() {
      $('.msg_for_user_btn').click(function() {
        if ($(this).hasClass('active')) {
          $(this).removeClass('active')
          $(this).parents('.chat_box_float_right').removeClass('chat_popup_actv')
        } else {
          $('.msg_for_user_btn').removeClass('active')
          $('.chat_box_float_right').removeClass('chat_popup_actv')
          $(this).addClass('active')
          $(this).parents('.chat_box_float_right').addClass('chat_popup_actv')
        }
      })
      $('.chat_box_close .fa').click(function() {
        $('.msg_for_user_btn').removeClass('active')
        $('.chat_box_float_right').removeClass('chat_popup_actv')
      })
      $('.chat_with_user_btn .btn-primary').click(function() {
        if ($(this).hasClass('active')) {
          $(this).removeClass('active')
          $('.video_dashb_custom_container').removeClass('video_show_with_sidebar')
        } else {
          $(this).addClass('active')
          $('.video_dashb_custom_container').addClass('video_show_with_sidebar')
        }
      })
    })
    this.localVideo = this.$refs.localVideo;

    this.checkNetWorkConnection(true);
    // now we listen for network status changes
    window.addEventListener('online', () => {
      this.checkNetWorkConnection();
    });

    window.addEventListener('offline', () => {
      this.checkNetWorkConnection(true);
    });
    if(this.isOnline) {
      if(this.hasUserMedia() && this.hasRTCPeerConnection()) {
        let safariVersion = 0;
        if(adapter.browserDetails.browser === 'safari') {
          safariVersion = this.getBrowserVersion()
        }
        if((adapter.browserDetails.browser == "chrome" && adapter.browserDetails.version > 50) || (adapter.browserDetails.browser == "firefox" && adapter.browserDetails.version > 45) || (adapter.browserDetails.browser == "safari" && safariVersion > 11)) {
          this.waitForCurrentUser()
            .then(() => {
              this.getUserMedia();
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          toast.error('Sorry, your browser does not support WebRTC.');
        }
      } else {
        toast.error('Sorry, your browser does not support WebRTC.');
      }
    } else {
        toast.error("Oh no ... we couldn't connect to internet.");
    }
  },
  methods: {
    getBrowserVersion() {
        var ua= navigator.userAgent, tem,
        M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if(/trident/i.test(M[1])){
            tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
            return 'IE '+(tem[1] || '');
        }
        if(M[1]=== 'Chrome'){
            tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
            if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
        }
        M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
        if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
        return M[1];
    },
    /*
    * this will check the network connection
    */
    checkNetWorkConnection(status = false) {
      const hasInternet = navigator.onLine;
      this.isOnline = hasInternet;
      if(status && !hasInternet) {
        this.hasInternetConnection = hasInternet;
      }
    },
    /*
    * those function for screen expandable
    */
    miniMizeMblFullScreen(){
      if ($('body').hasClass('one_video_dashboard')) {
        $('body').removeClass('one_video_dashboard')
        $('body').removeClass('one_video_full_dashboard')
      } else {
        $('body').addClass('one_video_dashboard')
      }
    },
    miniMizeScreen(){
      $('body').addClass('one_video_dashboard')
    },
    miniMizeFullScreen(){
      if ($('body').hasClass('one_video_full_dashboard')) {
        $('body').removeClass('one_video_dashboard')
        $('body').removeClass('one_video_full_dashboard')
      } else {
        $('body').addClass('one_video_full_dashboard')
      }
    },
    /*
    * this will check if user has getUserMedia
    */
    hasUserMedia() {
      navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
      return !!navigator.getUserMedia;
    },
    /*
    * this will check that user browser supports webrtc or not
    */
    hasRTCPeerConnection() {
      window.RTCPeerConnection = window.RTCPeerConnection || window.webkitRTCPeerConnection || window.mozRTCPeerConnection;
      window.RTCSessionDescription = window.RTCSessionDescription || window.webkitRTCSessionDescription || window.mozRTCSessionDescription;
      window.RTCIceCandidate = window.RTCIceCandidate || window.webkitRTCIceCandidate || window.mozRTCIceCandidate;
      return !!window.RTCPeerConnection;
    },
    /*
    * this will check for the currentUser Id
    */
    waitForCurrentUser() {
      return new Promise((resolve, reject) => {
        let interval = setInterval(()=>{
          this.currentUser =  this.userIdForRoomId;
          if(this.currentUser != undefined && this.currentUser != "") {
            console.log(`Current User Id is ${this.currentUser}`);
            clearInterval(interval);
            resolve();
          }
        }, 100);
      });
    },
    /*
    * this will get the access the user media(video/audio) from browser
    */
    getUserMedia() {
      if ("mediaDevices" in navigator) {
        try {
          navigator.mediaDevices.getUserMedia(this.constraints).then(mediaStream => {
            if('srcObject' in this.localVideo) {
                this.localVideo.srcObject = mediaStream;
              } else {
                this.localVideo.src = window.URL.createObjectURL(mediaStream); /* fallback for old browsers */
              }
              this.localStream = mediaStream;
              const video = this.localStream.getVideoTracks();
              const audio = this.localStream.getAudioTracks();

              if (video.length > 0) console.log(`Using video device: ${video[0].label}`)
              if (audio.length > 0) console.log(`Using audio device: ${audio[0].label}`)

              socketRef.connect(this.roomID);
              this.processSignalingMessage();
          });
        } catch(error) {
          console.log(`getUserMedia error: ${error}`);
          toast.error(`${error}`);
        }
      } else {
        toast.error('Sorry, your browser does not support WebRTC.');
      }
    },
    /*
    * this will process all the signaling message through websocket
    */
    processSignalingMessage() {
      socketRef.$on('connection', this.doConnectionEvent);
      socketRef.$on('sessionCreated', this.doSessionEvent);
      socketRef.$on('joinRoom', this.doJoinRoomEvent);
      socketRef.$on('offer', this.doOfferEvent);
      socketRef.$on('answer', this.doAnswerEvent);
      socketRef.$on("ice-candidate", this.handleNewICECandidate);
      socketRef.$on("screen-share", this.handlePeerShareScreen);
      socketRef.$on("audioStream", this.handleAudioStreamEvent);
      socketRef.$on("videoStream", this.handleVideoStreamEvent);
      socketRef.$on("leftRoom", this.handlePeerLeftRoomEvent);
      socketRef.$on("roomFull", this.handleRoomFullEvent);
    },
    doConnectionEvent(response) {
      const payload = {
        message: "connection created",
        type: "connectionCreated",
        userID: this.currentUser
      };
      socketRef.emit(payload);
    },
    /*
    * this will get ICEServers and emit join the room message
    */
    doSessionEvent(response) {
      try {
        if(this.configuration == undefined) {
          this.configuration = {
            iceServers: response.iceServers
          };
          socketRef.emit({
            message: `${this.userFullName} Joined Room`,
            type: "joinRoom",
            displayName: this.userFullName,
            userID: this.currentUser,
            targetId: 'all'
          })
        }
      } catch(error) {
          console.log(`session event error: ${error}`);
          toast.error(`${error}`, "Session Event Error");
      }
    },
    /*
    * this will handle the user joined room event and start connection
    */
    doJoinRoomEvent(signal) {
      const peerUuid = signal.userID;

      // Ignore messages that are not for us or from ourselves
      if(peerUuid == this.currentUser || (signal.targetId != this.currentUser && signal.targetId != 'all')) return;
      try {

        //disable screen share if someone already started
        if(!this.isScreenSharing) {
          if(signal.screenShare) {
            this.disableScreenSharing = signal.screenShare;
            this.screenSharedPeerUuuid = signal.screenShareUser;
          } else {
            this.disableScreenSharing = false;
          }
        }
        // check for new coming peer
        if(signal.displayName && signal.targetId == 'all') {

            // set up peer connection object for a newcomer peer
            this.setUpPeer(peerUuid, signal.displayName, false);

        } else if (signal.displayName && signal.targetId == this.currentUser) {

            // initiate call if we are the newcomer peer
            this.setUpPeer(peerUuid, signal.displayName, true);
        }
      } catch (error) {
          console.log(`join event error: ${error}`);
          toast.error(`${error}`, "Join Event Error");
      }
    },
    /*
    * this will handle the SDP signal sending to peer connection when has offer
    */
    doOfferEvent(signal) {
      const peerUuid = signal.userID;

      // Ignore messages that are not for us or from ourselves
      if(peerUuid == this.currentUser || (signal.targetId != this.currentUser && signal.targetId != 'all')) return;
      try {
        const peer = this.peerConnections[peerUuid].peerConnection;
        console.log(`Offer Signaling State ${peer.signalingState}`);
        const desc = new RTCSessionDescription(signal.sdp);
        peer.setRemoteDescription(desc).then(() => {
          peer.createAnswer().then(
            description => this.setLocalDescription(description, peerUuid, "answer")
          ).catch(e => console.log(e));
        }).catch(e => console.log(e));
      } catch(error) {
          console.log(`Offer event error: ${error}`);
          toast.error(`${error}`, "Offer Event Error");
      }
    },
    /*
    * this will handle the sdp signal sending to peer connection when has answer
    */
    doAnswerEvent(signal) {
      const peerUuid = signal.userID;

      // Ignore messages that are not for us or from ourselves
      if(peerUuid == this.currentUser || (signal.targetId != this.currentUser && signal.targetId != 'all')) return;
      try {
        const peer = this.peerConnections[peerUuid].peerConnection;
        console.log(`Answer Signaling State ${peer.signalingState}`);
        const desc = new RTCSessionDescription(signal.sdp);
        peer.setRemoteDescription(desc).catch(e => console.log(e));
        setTimeout(() => {
          this.peerConnections[peerUuid].localICECandidates.forEach((candidate, i) => {
            ((i) => {
              setTimeout(() => {
                console.log(`Sending local ICE candidate (${candidate.address}) for ${this.currentUser} to ${peerUuid}`);
                const payload = {
                  message: "ICE candidate",
                  type: "ice-candidate",
                  targetId: peerUuid,
                  userID: this.currentUser,
                  candidate: candidate,
                }
                socketRef.emit(payload);
              },80 * i);
            })(i);
          });
          this.peerConnections[peerUuid].localICECandidates = [];
        },100);
      } catch(error) {
          console.log(`Answer event error: ${error}`);
          toast.error(`${error}`, "Answer Event Error");
      }
    },
    /*
    * this will create the new RTCPeerconnection for that user
    */
    setUpPeer(peerUuid, displayName, initiator) {
      try {
        const peerConnection = new RTCPeerConnection(this.configuration);
        peerConnection.onicecandidate = event => this.gotIceCandidate(event, peerUuid, displayName);
        peerConnection.ontrack = event => this.handleTrackEvent(event, peerUuid);
        peerConnection.onsignalingstatechange = event => this.onSignalingChange(event, peerUuid, displayName);
        peerConnection.oniceconnectionstatechange = event => this.handleCheckPeerDisconnect(event, peerUuid, displayName);
        this.localStream.getTracks().forEach(track => peerConnection.addTrack(track, this.localStream));

        this.peerConnections[peerUuid] = {
          peerConnection: peerConnection,
          displayName: displayName,
          peerUuid: peerUuid,
          isAudioMuted: false,
          isVideoMuted: true,
          isConnected: false,
          sdpType: '',
          localICECandidates: [],
          mediaStream: ''
        };
        console.log(`Total Peers ${Object.values(this.peerConnections).length}`);

        if(!initiator) {
          socketRef.emit({
            message: `${this.userFullName} Joined Room`,
            type: "joinRoom",
            displayName: this.userFullName,
            userID: this.currentUser,
            targetId: peerUuid
          });
        }

        if(initiator) {
          this.peerConnections[peerUuid].peerConnection.createOffer().then(
            description => this.setLocalDescription(description, peerUuid, "offer")
          ).catch(e => console.log(e));
        }

      } catch(error) {
          console.log(`setup peer error: ${error}`);
          toast.error(`${error}`, "Setup Peer Error");
      }
    },
    /*
    * this will set Local Description in peer connection
    */
    setLocalDescription(description, peerUuid, sdpType) {
      try {
        console.log(`got description, peer ${peerUuid}`);
        this.peerConnections[peerUuid].peerConnection.setLocalDescription(description).then(() => {
          this.peerConnections[peerUuid].sdpType = sdpType;
        }).catch(e => console.log(e));
      } catch (error) {
        console.log(`local description error: ${error}`);
        toast.error(`${error}`, "Local Description Error");
      }
    },
    /*
    * this will gather all the ice candidates and send to peer
    */
    gotIceCandidate(event, peerUuid, displayName) {
      if(event.candidate) {
        if(this.filterIceCandidate(event.candidate)) {
          console.log(`Received local ICE candidate for ${peerUuid} (${event.candidate.address})`);
          this.peerConnections[peerUuid].localICECandidates.push(event.candidate);
          console.log(`Adding local candidates ${peerUuid}`);
        }
      }
      if(event.candidate == null) {
        const sdpType = this.peerConnections[peerUuid].sdpType;
        console.log(`Candidate completed for ${peerUuid}`);
        console.log(`Total Local candidates ${this.peerConnections[peerUuid].localICECandidates.length}`);
        console.log(`Peer in ${this.peerConnections[peerUuid].peerConnection.signalingState} state`);
        console.log(`SDP type ${sdpType}`);
        const payload = {
          type: sdpType === 'offer' ? 'offer' : 'answer',
          message: `Sending ${sdpType} signal`,
          targetId: peerUuid,
          userID: this.currentUser,
          sdp: this.peerConnections[peerUuid].peerConnection.localDescription
        };
        socketRef.emit(payload);
        setTimeout(() => {
          if(sdpType === "answer") {
            this.peerConnections[peerUuid].localICECandidates.forEach((candidate, i) => {
              ((i) => {
                setTimeout(() => {
                  console.log(`Sending local ICE candidate (${candidate.address}) for ${this.currentUser} to ${peerUuid}`);
                  const payload = {
                    message: "ICE candidate",
                    type: "ice-candidate",
                    targetId: peerUuid,
                    userID: this.currentUser,
                    candidate: candidate,
                  }
                  socketRef.emit(payload);
                },80 * i);
              })(i);
            });
            this.peerConnections[peerUuid].localICECandidates = [];
          }
        },100);
      }
    },
    /*
    * this will get the remote candidates and add them
    */
    handleNewICECandidate(signal) {
      const peerUuid = signal.userID;

      // Ignore messages that are not for us or from ourselves
      if(peerUuid == this.currentUser || (signal.targetId != this.currentUser && signal.targetId != 'all')) return;

      try {
        let peer = this.peerConnections[peerUuid].peerConnection;
        const candidate = new RTCIceCandidate(signal.candidate);
        console.log(`Received remote ICE candidate (${candidate.address} - ${candidate.relatedAddress})`)
        peer.addIceCandidate(candidate)
          .then(() => {
            console.log("Remote candidate added successfully");
          })
          .catch(e => console.log(e));
      } catch(error) {
        console.log(`Local ICE candidate event error: ${error}`);
        toast.error(`${error}`, "Local ICE Candidate Event Error");
      }
    },
    /*
    * this will handle the remote stream event add that in local
    */
    handleTrackEvent(event, peerUuid) {
      console.log(`got remote stream, peer ${peerUuid}`);
      if(this.peerConnections[peerUuid].mediaStream == "") {
        this.peerConnections[peerUuid].mediaStream = event.streams[0];
        this.peers.push(this.peerConnections[peerUuid]);
        this.peerConnections[peerUuid].isVideoMuted = false;
      }
      if(this.peers && this.peers.length === 1){
        this.screenExpandbleOption =  true
        $('body').addClass('one_video_dashboard')
        $('body').addClass('one_video_full_dashboard')
      } else {
        if(this.disableScreenSharing) {
          this.screenExpandbleOption =  true
          $('body').addClass("screen_sharing_enabled");
          $('body').addClass('one_video_dashboard');
          $('body').addClass('one_video_full_dashboard')
        } else {
        this.screenExpandbleOption =  false
          $('body').removeClass('one_video_dashboard')
          $('body').removeClass('one_video_full_dashboard')
        }
      }
    },
    /*
    * this will handle the peer connection state changes
    */
    handleCheckPeerDisconnect(event, peerUuid, displayName) {
      try {
        const peer = this.peerConnections[peerUuid];
        if (peer) {
          var state = peer.peerConnection.iceConnectionState;
          console.log(`connection with peer ${peerUuid} ${state}`);
        }
      } catch(error) {
          console.log(`Connection event error: ${error}`);
          toast.error(`${error}`, "Connection Event Error");
      }
    },
    /*
    * this will filter the ICE candidates
    */
    filterIceCandidate(candidate) {
      const candidateStr = candidate.candidate;
      if(candidateStr.indexOf("tcp") !== -1) {
        return false;
      }
      return true;
    },
    /*
    * this will print the peer connection's signalingState
    */
    onSignalingChange(event, peerUuid, displayName) {
      let pc = this.peerConnections[peerUuid].peerConnection;
      if(pc) {
        console.log(`${this.currentUser} -> ${peerUuid} in ${pc.signalingState} state`);
      }
    },
    /*
    * this will handle the video/audio enable/disable feature
    */
    toggleMediaStream(mediaType) {
      try {
        if(mediaType === "audio") {
          this.localStream.getAudioTracks().forEach(t => (t.enabled = !t.enabled));
          this.isAudioMuted = !this.isAudioMuted;
          socketRef.emit({
            message: "Audio stream changed",
            type: "audioStream",
            isAudioMuted: this.isAudioMuted,
            userID: this.currentUser,
            targetId: 'all'
          });
        } else if(mediaType === "video") {
            this.localStream.getVideoTracks().forEach(t => (t.enabled = !t.enabled));
            this.isVideoMuted = !this.isVideoMuted;
            socketRef.emit({
              message: "Video stream changed",
              type: "videoStream",
              isVideoMuted: this.isVideoMuted,
              userID: this.currentUser,
              targetId: 'all'
            });
        }
      } catch(error) {
          console.log(`Media event error: ${error}`);
          toast.error(`${error}`, "Media Event Error");
      }
    },
    /*
    * this will handle the peer audio enable/disable event
    */
    handleAudioStreamEvent(incoming) {
      try {
        if(incoming.userID && incoming.targetId === "all") {
          const index = this.peers.findIndex(peer => peer.peerUuid === incoming.userID);
          if(index > -1) {
            this.peers[index].isAudioMuted = incoming.isAudioMuted;
          }
        }
      } catch(error) {
          console.log(`Audio strem error ${error}`);
      }
    },
    /*
    * this will handle the peer video enable/disable event
    */
    handleVideoStreamEvent(incoming) {
      try {
        if(incoming.userID && incoming.targetId === "all") {
          const index = this.peers.findIndex(peer => peer.peerUuid === incoming.userID);
          if(index > -1) {
            this.peers[index].isVideoMuted = incoming.isVideoMuted;
          }
        }
      } catch(error) {
          console.log(`Video strem error ${error}`);
      }
    },
    /*
    * this will handle the end call for currentUser
    */
    endCall() {
      this.handleStopScreenShare(); // to stop the screen sharing before end call
      let allPeers = Object.values(this.peerConnections);
      if(allPeers && allPeers.length > 0) {
        allPeers.forEach(peer => {
          peer.peerConnection.close();
          peer.peerConnection.onicecandidate = null;
          peer.peerConnection.ontrack = null;
          peer.peerConnection.onsignalingstatechange = null;
          peer.peerConnection.oniceconnectionstatechange = null;
          peer.peerConnection = null;
        });
        this.peerConnections = {};
        this.peers.splice(0,this.peers.length);
        $('body').removeClass('one_video_dashboard')
        $('body').removeClass('one_video_full_dashboard')
        socketRef.close();
        window.location.href = '/video/user/left/room/#' + location.hash.substring(1);
      }
    },
    /*
    * this will handle the end call for currentUser
    */
    endCallForSelfUser() {
      this.handleStopScreenShare(); // to stop the screen sharing before end call
      $('body').removeClass('one_video_dashboard')
      $('body').removeClass('one_video_full_dashboard')
      socketRef.close();
      window.location.href = '/video/user/left/room/#' + location.hash.substring(1);
    },
    /*
    * this will handle the peer left room event
    */
    handlePeerLeftRoomEvent(signal) {
      if(signal.userID == this.screenSharedPeerUuuid) {
        this.screenSharedPeerUuuid = "";
        this.disableScreenSharing = false;
        socketRef.emit({
          message: "Stop Screen Sharing",
          type: "stopScreenShare",
          userID: signal.userID
        });
        $('body').removeClass('screen_sharing_enabled');
      }
      let peer = this.peerConnections[signal.userID];
      if(peer) {
        let peerName = this.peerConnections[signal.userID].displayName;
        this.peerConnections[signal.userID].peerConnection.close();
        this.peerConnections[signal.userID].peerConnection.onicecandidate = null;
        this.peerConnections[signal.userID].peerConnection.ontrack = null;
        this.peerConnections[signal.userID].peerConnection.onsignalingstatechange = null;
        this.peerConnections[signal.userID].peerConnection.oniceconnectionstatechange = null;
        this.peerConnections[signal.userID].peerConnection = null;
        delete this.peerConnections[signal.userID];
        const index = this.peers.findIndex(item => item.peerUuid === signal.userID);
        this.peers.splice(index,1);
        if(this.peers && this.peers.length === 1){
          this.screenExpandbleOption =  true
          $('body').addClass('one_video_dashboard')
          $('body').addClass('one_video_full_dashboard')
        } else {
          if(!this.disableScreenSharing) {
            this.screenExpandbleOption =  false
            $('body').removeClass('one_video_dashboard')
            $('body').removeClass('one_video_full_dashboard')
          }
        }
        toast.success(`${peerName} left the room`);
      }
    },
    /*
    * this will handle the roomFull event
    */
    handleRoomFullEvent(response) {
      if(response.userID === this.currentUser) {
        toast.error("Sorry, Room is full. You can create a new room");
        window.location.href = '/video/user/left/room/#' + location.hash.substring(1);
        socketRef.close();
      }
    },
    /*
    * this will handle the scree share when peer started screen sharing
    */
    handlePeerShareScreen(signal) {
      const peerUuid = signal.userID;
      // Ignore messages that are not for us or from ourselves

      if(peerUuid == this.currentUser) return;
      try {
        this.disableScreenSharing = signal.disableScreenSharing;
        if(signal.disableScreenSharing) {
          if(signal.peerSize > 1) {
            $('body').addClass("screen_sharing_enabled");
            $('body').addClass("one_video_dashboard");
            $('body').addClass("one_video_full_dashboard");
            this.screenSharedPeerUuuid = signal.userID;
          }
        } else {
            if(signal.peerSize > 1) {
              $('body').removeClass("one_video_dashboard")
              $('body').removeClass("one_video_full_dashboard")
              $('body').removeClass("screen_sharing_enabled")
              this.screenSharedPeerUuuid = ''
            }
        }
      } catch(error) {
          console.log(`Screen Share Peer error: ${error}`);
          toast.error(`${error}`, "Screen Share Peer Error");
      }
    },
    /*
    * this will handle the screen share event
    */
    handleShareScreen() {
      if ("mediaDevices" in navigator) {
        try {
          navigator.mediaDevices.getDisplayMedia(this.screenShareConstraints).then(stream => {
              const screenTrack = stream.getTracks()[0];
              let allPeers = Object.values(this.peerConnections);
              if(allPeers && allPeers.length > 0) {
                allPeers.forEach(peer => {
                  let senderPeer = peer.peerConnection.getSenders().find(function(sender) {
                    return sender.track.kind == screenTrack.kind;
                  });
                  senderPeer.replaceTrack(screenTrack);
                });
                screenTrack.onended = () => {
                  this.handleStopScreenShare();
                }
                this.isScreenSharing = true;
                socketRef.emit({
                  message: "Start Screen Sharing",
                  type: "startScreenShare",
                  userID: this.currentUser
                });
                socketRef.emit({
                  message: "Screen Share Starts",
                  type: "screen-share",
                  userID: this.currentUser,
                  targetId: "all",
                  disableScreenSharing: true,
                  peerSize:allPeers.length
                });
              }
          });
        } catch(error) {
            console.log(`Screen Share event error: ${error}`);
            toast.error(`${error}`, "Screen Share Event Error");
        }
      } else {
          toast.error('Sorry, your browser does not support WebRTC.');
      }
    },
    /*
    * this will handle the stop screen share
    */
    handleStopScreenShare() {
      if(this.isScreenSharing) {
        let allPeers = Object.values(this.peerConnections);
        if(allPeers && allPeers.length > 0) {
          allPeers.forEach(peer => {
            let senderPeer = peer.peerConnection.getSenders().find(function(sender) {
              return sender.track.kind == "video";
            });
            senderPeer.replaceTrack(this.localStream.getTracks()[1]);
          });
          this.isScreenSharing = false;
          socketRef.emit({
            message: "Stop Screen Sharing",
            type: "stopScreenShare",
            userID: this.currentUser
          });
          socketRef.emit({
            message: "Screen Share Stop",
            type: "screen-share",
            userID: this.currentUser,
            targetId: "all",
            disableScreenSharing: false,
            peerSize: allPeers.length
          });
        }
      }
    },
    rejoinRoom(){
      window.location.reload();
    },
    redirectToHome() {
      window.location.href = "/home/";
    }
  },
  beforeDestroy() {
    console.log("Router destroying");
    if(this.localStream) {
      this.localStream.getTracks().forEach(track => track.stop());
    }
    if(socketRef.isOpen() != "") {
      socketRef.close();
    }
    let allPeers = Object.values(this.peerConnections);
    if(allPeers && allPeers.length > 0) {
      allPeers.forEach(peer => {
        peer.peerConnection.close();
        peer.peerConnection.onicecandidate = null;
        peer.peerConnection.ontrack = null;
        peer.peerConnection.onsignalingstatechange = null;
        peer.oniceconnectionstatechange = null;
        peer.peerConnection = null;
      });
    }
    console.log("Router Destroyed");
  },
  beforeCreate: function() {
    $('body').addClass('video_conference_page');
    if(videoSocketRef.isOpen() != "") {
      videoSocketRef.close()
    }
  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('video_conference_page')
    $('body').removeClass('one_video_dashboard')
    $('body').removeClass('one_video_full_dashboard')
    let callerID = '3548d149becb44e9'
    videoSocketRef.connect(callerID);
    next();
  },
  watch: {
    getUserDetailsInfo(){
      return this.$store.getters.acUserDetailsStateGetters
    },
    setIntialUserIdFun(){
      if(this.userProfileDetails != undefined){
        this.userIdForRoomId = this.userProfileDetails.id
        this.userFullName = this.userProfileDetails.first_name + ' ' + this.userProfileDetails.last_name
      }
    }
  },
}
